const rawTimeLoading = process.env.REACT_APP_TIME_LOADING;
const parsedTimeLoading = rawTimeLoading != null ? parseInt(rawTimeLoading, 10) : NaN;
export const TIME_LOADING =
  !Number.isNaN(parsedTimeLoading) && parsedTimeLoading >= 0 ? parsedTimeLoading : 600; // milliseconds
export const RANGE_LOADING = [-30, 30]; // percentage
export const HOME_PRELOAD_TIMEOUT = 8000;

const rawWaitForDownload = process.env.REACT_APP_WAIT_FOR_DOWNLOAD_STATUS_SECONDS;
const parsedWaitForDownload = rawWaitForDownload != null ? parseInt(rawWaitForDownload, 10) : NaN;
export const WAIT_FOR_DOWNLOAD_STATUS_TIMEOUT =
  (!Number.isNaN(parsedWaitForDownload) && parsedWaitForDownload > 0 ? parsedWaitForDownload : 10) * 1000; // convert to ms

export const STEPS = [
  "Récupération du DPE",
  "Extraction des données du DPE",
  "Collecte et agrégation de données externes",
  "Analyse des données par l'algorithme checkDPE",
  "Calcul du score de fiabilité",
  "Préparation du rapport",
  "Votre rapport checkDPE est prêt",
];
